import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/lib/utils";

type ListBlockProps = {
  variant?: "divider" | "subtle";
  title?: string;
  children: ReactNode;
} & ComponentProps<"div">;

const ListBlock = ({
  variant = "divider",
  title,
  children,
  className,
  ...rest
}: ListBlockProps) => {
  const isDivider = variant === "divider";

  return (
    <div className={cn("flex flex-col", className)} {...rest}>
      {title && <p className="text-copy-bold mb-2">{title}</p>}
      <div
        className={cn(
          "flex flex-col",
          isDivider ? "gap-2" : "gap-3",
          isDivider &&
            "[&>*]:pb-2 [&>*]:border-b [&>*]:border-[rgba(0,0,0,0.12)]",
        )}
      >
        {children}
      </div>
    </div>
  );
};

export { ListBlock };
